import styled from 'styled-components';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 420px;
  max-width: 420px;

  display: flex;
  flex-direction: column;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
    max-width: 100%;
  }
`;

export const Content = styled.div`
  padding: 28px;
`;

export const CropperWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 280px;

  background-color: ${colors.surfaceContainerHighest};
  border-radius: ${radius.DEFAULT};
  overflow: hidden;
`;

export const ZoomRow = styled.div`
  margin-top: 20px;

  input[type='range'] {
    width: 100%;
    accent-color: ${colors.primary};
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const Cancel = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Submit = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};
`;
